import React from 'react'
import { 
  Form, FormGroup, FormControl, ControlLabel
} from 'react-bootstrap'

import { getText } from '../../lib/text.js'

/**
 * Campo de Encargado
 */

// type EncargadoFieldProps = {
//   onClick: Object,  // evt
//   onChange: Object, // evt
//   value: string,
//   style: Object,
//   usernames: string[]
// }

const EncargadoField = ({ onClick, onChange, value, style, usernames }/* : EncargadoFieldProps */) => (
  <Form inline style={{ display: "inline-block", margin: 10, ...style }}>
    <FormGroup>
      <ControlLabel style={{ fontSize: 16 }}>👤 {getText("Encargado")}</ControlLabel>
      <FormControl
        componentClass="select"
        style={{ width: 100, marginLeft: 10 }}
        value={value || ""}
        onChange={evt => (evt.target.value === "Yo" ? onClick(evt) : onChange(evt))}
      >
        <option value="">{getText("Sin asignar")}</option>
        <option value="Yo">{getText("Yo")}</option>
        <option disabled >──────────</option>
        {
          (usernames || []).map(username => (
            <option value={username} key={username}>{username}</option>
          ))
        }
      </FormControl>
    </FormGroup>
  </Form>
)

export default EncargadoField